<template>
    <div class="footer">
        <div class="links">
            <a href="https://twitter.com/The_Odds_API">
                X.com
            </a>
            <span>•</span>
            <a href="https://bsky.app/profile/oddsapi.bsky.social">
                Bluesky
            </a>
            <span>•</span>
            <a href="https://github.com/the-odds-api">
                Github
            </a>
        </div>
        
        <div class="links">
            <a href="https://status.the-odds-api.com/">
                Status
            </a>
            <span>•</span>
            <a href="https://the-odds-api.com/terms-and-conditions.html">
                Terms
            </a>
            <span>•</span>
            <a href="https://the-odds-api.com/privacy.html">
                Privacy Policy
            </a>
            <span>•</span>
            <a href="mailto:team@the-odds-api.com">
                Contact
            </a>
        </div>

        <div class="copywrite">
            &copy; {{ year }} <a href="https://the-odds-api.com">The Odds API</a>
        </div>

    </div>
</template>
<script>
import { setAffiliateId, getAffiliateId } from '@/composables/affiliateFunctions.ts'

export default {
    mounted() {
        setAffiliateId()
    },
    computed: {
        year() {
            const today = new Date()
            return today.getFullYear()
        }
    }
}
</script>
<style scoped>

.footer {
    padding: 2rem 0 2rem 0;
    font-size: 14px;
}

.footer > .links {
    display: flex;
    justify-content: center;
    max-width: 35rem;
    margin: auto;
    padding-top: 1rem;
}

.footer > .links > span {
    display: inline-block;
    padding: 0 1rem;
    color: #3883fa;
}

.footer > .links > a {
    color: #999;
    font-size: 16px;
}

.copywrite {
    color: #999;
    text-align: center;
    padding-top: 2rem;
}

</style>
